import { offsetLimitPagination } from '@apollo/client/utilities';
import { mergeCoursesList } from '../utils/mergeCoursesList';
import Appointment from './Appointment';
import { ActivityChallenge } from './ActivityChallenge';
import { Image } from './Image';
import { Klass } from './Klass';
import { appointmentsList } from './appointmentsList';
import exercises from './exercises';
import PackageVariant from './packageVariant';
import PracticeItem from './PracticeItem';
import practiceItems from './practiceItems';
import recommendedClasses from './recommendedClasses';
import SectionCurriculum from './sections';
import { classes } from './classes';
import { StudentSubscriptionInfo } from './StudentSubscriptionInfo';
import { Student } from './Student';
import { CumulativeVocabWord } from './CumulativeVocabWord';
import { teacherLearningMaterials } from './teacherLearningMaterials';
import { TeacherInfo } from './TeacherInfo';
import { PublicAgreement } from './PublicAgreement';
import type { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
    ActivityChallenge,
    Appointment,
    Country: {
        keyFields: ['code'],
    },
    CumulativeVocabWord,
    FlashcardSet: {
        merge: true,
    },
    Image,
    Klass,
    LingobitesExercise: {
        keyFields: ['lessonId'],
    },
    LingobotExercise: {
        keyFields: ['lessonId'],
    },
    OnboardingAnswer: {
        keyFields: ['questionKey'],
    },
    PracticeItem,
    PublicAgreement,
    SectionCurriculum,
    Student,
    StudentLearningTeam: {
        keyFields: ['courseId'],
    },
    StudentSubscriptionInfo,
    StudentYearlyActivitySummary: {
        keyFields: ['year'],
    },
    TeacherInfo,
    Variant: PackageVariant,
    Query: {
        fields: {
            country: (_, { args, toReference }) =>
                toReference({
                    __typename: 'Country',
                    code: args?.code,
                }),
            exercises,
            practiceItems,
            appointmentsList,
            recommendedClasses,
            recommendedClass: (_, { args, toReference }) =>
                toReference({
                    __typename: 'RecommendedClass',
                    id: args?.classId,
                }),
            onboardingClass: (_, { args, toReference }) =>
                toReference({
                    __typename: 'Klass',
                    uid: args?.classId,
                }),
            section: (_, { args, toReference }) =>
                toReference({
                    __typename: 'Section',
                    id: args?.id,
                }),
            studentModule: (_, { args, toReference }) =>
                toReference({
                    __typename: 'StudentModule',
                    id: args?.id,
                }),
            class: (_, { args, toReference }) =>
                toReference({
                    __typename: 'Klass',
                    uid: args?.id,
                }),
            grammarItem: (_, { args, toReference }) =>
                toReference({
                    __typename: 'GrammarItem',
                    id: args?.id,
                }),
            lesson: (_, { args, toReference }) =>
                toReference({
                    __typename: 'Lesson',
                    id: args?.id,
                }),
            teacherInvoices: offsetLimitPagination(),
            teacherLearningMaterials,
            classes,
            teacherCourses: {
                keyArgs: false,
                merge: mergeCoursesList,
            },
            teacherActiveCourses: {
                keyArgs: false,
                merge: mergeCoursesList,
            },
        },
    },
};
